import type { RootState } from '~/reducers';
import { CountryCodeType, StateProvinceCodeType } from '~/types/types';

/**
 * Return list of countries in the world that could be used for billing addresses.
 */
export const getCountries = (state: RootState): Array<CountryCodeType> => state.address.countries;

/**
 * Return the list of US states with their abbreviations
 */
export const getUsStates = (state: RootState): Array<StateProvinceCodeType> =>
  state.address.usStates;

/**
 * Return the list of provinces in Canada
 */
export const getCaProvinces = (state: RootState): Array<StateProvinceCodeType> =>
  state.address.caProvinces;

/** Return true if region codes have been loaded */
export const getLoaded = (state: RootState): boolean => state.address.loaded;
